// https://github.com/ruyut/TaiwanCalendar/tree/master/data
import holidays2024 from './2024.json';
import holidays2025 from './2025.json';
import holidays2026 from './2026.json';

// 將兩個陣列合併
const holidays = [...holidays2024, ...holidays2025, ...holidays2026].filter(holiday => holiday.isHoliday);

// 匯出合併後的陣列
export default holidays;
